import { render, staticRenderFns } from "./-goods-zoom.vue?vue&type=template&id=5e8be931&scoped=true&"
import script from "./-goods-zoom.vue?vue&type=script&lang=js&"
export * from "./-goods-zoom.vue?vue&type=script&lang=js&"
import style0 from "./-goods-zoom.vue?vue&type=style&index=0&id=5e8be931&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8be931",
  null
  
)

export default component.exports